"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EMPTY_TYPES = {
    object: {},
    string: '',
    array: [],
    number: 0,
};
function getEmptyValueFromType(type) {
    return EMPTY_TYPES[type];
}
exports.getEmptyValueFromType = getEmptyValueFromType;
function getType(target) {
    // For example, [object Array]​​​​​ will be split into ['[object', 'Array]'].
    var _a = Object.prototype.toString.call(target).split(' '), back = _a[1];
    var type = back && back.replace(']', '').toLowerCase();
    return type;
}
exports.getType = getType;
function getCleanValueFromTypes(typesObj) {
    return Object.keys(typesObj).reduce(function (accu, typekey) {
        accu[typekey] = getEmptyValueFromType(typesObj[typekey]);
        return accu;
    }, {});
}
exports.getCleanValueFromTypes = getCleanValueFromTypes;



// WEBPACK FOOTER //
// ./src/dist/commonjs/helpers/types.js